var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 20,
    viewBox: "0 0 65 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_414_215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 20,
    fill: "url(#pattern0_414_215)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_414_215)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -21,
    y: -20,
    width: 109,
    height: 63,
    fill: "#F4C324"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_414_215",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_414_215",
    transform: "scale(0.0153846 0.05)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_414_215",
    width: 65,
    height: 20,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAUCAYAAADStFABAAABBUlEQVRYCe3YvQ4BQRAH8BOFRqPWegy9J6DW3nxccqGgFiI6BbVGp1GoJBrxMnprVCu7iUuE4KKbvU32AfZ3O//bmegKfNKwBWl3RZrk3QaTTqQBIDsDJus8CIaob5kruhCATwZo8RsEj0ya1iO3MkUtZQF8EMTZVwhImh5AI4L7qIK0/YgA3LXWllQjOIgb0uodxA2T4RmgmgFovQm+xJGPBnj+DMFjAWg8AahG8BlHe0GePiCEqPUCoB/B58PGIQhybNvtcpAIPiiBFnYwqL0FCOEm+HyIeRk0giD5criEWw6hB2PxiyweS8WzWVwDFQfeQEnwrTRSrqGKAPdUDVX+Ga/dAaj/VJY0IM07AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.9c68da27576afe956991578509236b64.svg";
export { ForwardRef as ReactComponent };